import React from 'react';
import { Navigate, useOutletContext } from 'react-router-dom';

import { PageLayoutContext } from '../../../interfaces';
import { useLegacyPage } from './legacy.hook';

export const LegacyPage = React.memo(() => {
  const { errorCode, faq } = useOutletContext<PageLayoutContext>();
  const { navigateProps } = useLegacyPage({
    errorCode,
    faq,
  });

  // @NOTE We need to return null if the page is not ready to avoid a blinking page
  // eslint-disable-next-line react/jsx-props-no-spreading
  return (navigateProps && <Navigate {...navigateProps} />) || null;
});

LegacyPage.displayName = 'LegacyPage';
